import { render, staticRenderFns } from "./VersionComponentInfo.vue?vue&type=template&id=7d554562&scoped=true"
import script from "./VersionComponentInfo.vue?vue&type=script&lang=js"
export * from "./VersionComponentInfo.vue?vue&type=script&lang=js"
import style0 from "./VersionComponentInfo.vue?vue&type=style&index=0&id=7d554562&prod&lang=less&scoped=true"
import style1 from "./VersionComponentInfo.vue?vue&type=style&index=1&id=7d554562&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d554562",
  null
  
)

export default component.exports